import { render, staticRenderFns } from "./ContentBlockSaleTop.vue?vue&type=template&id=fbeaac60&scoped=true&"
import script from "./ContentBlockSaleTop.vue?vue&type=script&lang=ts&"
export * from "./ContentBlockSaleTop.vue?vue&type=script&lang=ts&"
import style0 from "./ContentBlockSaleTop.vue?vue&type=style&index=0&id=fbeaac60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeaac60",
  null
  
)

export default component.exports